import "./PrimeDataGridWithColumnToggledStyle.css";

import {
	BackdropCircularProgress,
	RequestParams,
} from "@websential/cosmic-v20";
import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReactSeverity,
	addDashesInSIN,
	formatDate,
	formatDateToShow,
	formatPhoneNo,
	getDDLLabelByValue,
	getDDLValueByLabel,
	getProvinceDDLValueByShortCode,
	useNavigateToLogout,
} from "../../common/Common";
import { GridRenderCellParams, GridRowSelectionModel } from "@mui/x-data-grid";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { CountryService } from "../../services/common/CountryService";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { IAppState } from "../../store/reducers";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import SearchIcon from "@mui/icons-material/Search";
import { SkeletonLoadingDataGrid } from "../SkeletonLoadingDataGrid";
import { useSelector } from "react-redux";
import { useStickyDataTableHeader } from "../../common/useStickyDataTableHeader";

export interface IDataTable {
	rows: any;
	columns: any;
	completeHeaderColumnsList: any;
	submitAddRemoveColumnsHandler: (value: any) => void;
	onColumnReorder: (value: any) => void;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	showSettingColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: any) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	cardHeaderTitle?: string;
	cardHeaderSubTitle?: string;
	disabledHeaderTooltip?: boolean;
	viewIcon?: boolean;
	whiteSpace?: string;
	exportButton?: boolean;
	exportButtonLabel?: string;
	exportButtonInFileList?: boolean;
	onExportButtonClick?: (event: string, params: any) => void;
	onExportButtonInFileListClick?: (event: string, params: any) => void;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	provinceOfEmployementDDL?: any;
	countryList?: any;
	provinceOrStateDDL?: any;
	employeeListTableData: (data: any) => void;
	payFrequencyDDLItems?: any
	companyInformation?: any
	maskStatus?: any
}

export const PrimeDataGridWithColumnToggled: React.FC<IDataTable> = ({
	rows,
	columns,
	completeHeaderColumnsList,
	submitAddRemoveColumnsHandler,
	onColumnReorder,
	showIndexColumn,
	showChecboxColumn,
	showSettingColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	cardHeaderTitle,
	cardHeaderSubTitle,
	disabledHeaderTooltip = false,
	viewIcon,
	whiteSpace,
	exportButton = false,
	exportButtonLabel = "file",
	exportButtonInFileList = false,
	onExportButtonClick,
	onExportButtonInFileListClick,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	countryList,
	provinceOfEmployementDDL,
	employeeListTableData,
	payFrequencyDDLItems,
	companyInformation,
	maskStatus,
}) => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const navigateToLogout = useNavigateToLogout();
	const [completeHeaderColumnsListState, setCompleteHeaderColumnsListState] =
		useState({});
	const [columnss, setColumnss] = useState<any>([]);
	const [visibleColumns, setVisibleColumns] = useState<any>([]);
	const [employeeListData, setEmployeeListData] = useState<any>(rows && rows);
	const [employeeListItems, setEmployeeListItems] = useState<any>(undefined);

	// useEffect(() => {
	// 	if (rows) {
	// 		setEmployeeListData(rows);
	// 	}
	// }, [rows]);

	useEffect(() => {
		if (rows && JSON.stringify(rows) !== JSON.stringify(employeeListItems)) {
			setEmployeeListItems(rows);
		}
	}, [rows]);

	useEffect(() => {
		employeeListTableData(employeeListItems);

	}, [employeeListItems]);

	useEffect(() => {
		if (
			completeHeaderColumnsList &&
			Object.keys(completeHeaderColumnsList).length > 0
		) {
			setCompleteHeaderColumnsListState(completeHeaderColumnsList);
		}
	}, [completeHeaderColumnsList]);



	// const columnss = Object.entries(completeHeaderColumnsListState).map(
	// 	([field, status]) => ({
	// 		field,
	// 		headerName: field
	// 		.replace(/([A-Z])/g, " $1")
	// 			.replace(/^./, (c) => c.toUpperCase()),
	// 		status,
	// 	})
	// );

	useEffect(() => {
		if (Object.keys(completeHeaderColumnsListState).length > 0) {
			const updatedColumns = Object.entries(completeHeaderColumnsListState).map(
				([field, status]) => ({
					field,
					headerName: field
						.replace(/([A-Z])/g, " $1")
						.replace(/^./, (c) => c.toUpperCase()),
					status,
				})
			);
			setColumnss(updatedColumns);
			setVisibleColumns(updatedColumns.filter((col) => col.status));
		}
	}, [completeHeaderColumnsListState]);


	const [
		upadtedCompleteHeaderColumnsList,
		setUpadtedCompleteHeaderColumnsList,
	] = useState(columnss);
	// const [visibleColumns, setVisibleColumns] = useState(
	// 	columnss.filter((col) => col.status)
	// );
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedAuditEarningsItems, setSelectedAuditEarningsItems] =
		useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);

	const editColumn = (params: any) => {
		return (
			<>
				<EnhancedButtonPrimeReact
					icon={"pi pi-pencil"}
					onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/>
			</>
		);
	};

	const deleteRowColumn = (params: any) => {
		return (
			<EnhancedButtonPrimeReact
				icon="pi pi-times"
				onClickHandler={() =>
					onRowDeleteClicked && onRowDeleteClicked(params)
				}
				severity={EnhancedButtonPrimeReactSeverity.Danger}
				className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
				rounded
			/>
		);
	};
	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));

		// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
		// if (onRequestParamsChange) {
		// 	onRequestParamsChange({
		// 		first: initialPage,
		// 		rows: initialPageSize,
		// 		page: initialPage,
		// 		searchQuery: itemSearch,
		// 		sortOrder: requestParams.sortOrder,
		// 		sortField: requestParams.sortField,
		// 	});
		// }

		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => setLoading(false), 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));

		// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
		// if (onRequestParamsChange) {
		// 	onRequestParamsChange({
		// 		first: initialPage,
		// 		rows: initialPageSize,
		// 		page: initialPage,
		// 		searchQuery: "",
		// 		sortOrder: requestParams.sortOrder,
		// 		sortField: requestParams.sortField,
		// 	});
		// }
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => setLoading(false), 1000);
	};

	const onColumnToggle = (event: any) => {
		let selectedColumns = event.value;
		let orderedSelectedColumns = columnss.filter((col: any) =>
			selectedColumns.some((sCol: any) => sCol.field === col.field) ||
			[
				"firstName",
				"lastName",
				"dateOfBirth",
				"addressLine1",
				"country",
				"province",
				"city",
				"postCode",
				"dateOfHire",
				"stubLanguage",
				"emailStub",
				"printHourlyRateOnStub",
				"payMethod",
				"gender",
				"provinceOfEmployment",
			].includes(col.field)
		);

		setVisibleColumns(orderedSelectedColumns);



		const currentColumnsStatus = columnss.map((col: any) => {
			const match = orderedSelectedColumns.find(
				(selected: { field: any }) => selected.field === col.field
			);
			return {
				...col,
				// status: match ? match.status : false,
				status: match ? true : false,
			};
		});
		setUpadtedCompleteHeaderColumnsList(currentColumnsStatus);

	};

	const onColumnSaveButtonClickedHandler = () => {
		const convertArrayToObjectOfAllColumnsFields =
			upadtedCompleteHeaderColumnsList.reduce(
				(acc: any, { field, status }: any) => ({ ...acc, [field]: status }),
				{}
			);


		submitAddRemoveColumnsHandler(convertArrayToObjectOfAllColumnsFields);
	};

	const panelFooterTemplate = () => {
		return (
			<div
				className="py-2 px-3"
				style={{
					display: "flex",
					justifyContent: "end",
				}}
			>
				<EnhancedButtonPrimeReact
					label="Save"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					onClickHandler={onColumnSaveButtonClickedHandler}
				/>
			</div>
		);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div
					style={{
						fontSize: "1.5rem",
						fontWeight: "bold",
						fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
					}}
				>
					{pageTitle}
				</div>
				<MultiSelect
					value={visibleColumns}
					options={columnss}
					optionLabel="headerName"
					onChange={onColumnToggle}
					className="w-full sm:w-20rem"
					// display="comma"
					placeholder="Add/Remove Columns"
					maxSelectedLabels={0}
					selectedItemsLabel="Add/Remove Columns"
					panelFooterTemplate={panelFooterTemplate}
					optionDisabled={(option) =>
						option.field === "firstName" ||
						option.field === "lastName" ||
						option.field === "dateOfBirth" ||
						option.field === "addressLine1" ||
						option.field === "country" ||
						option.field === "province" ||
						// option.field === "states" ||
						option.field === "city" ||
						option.field === "postCode" ||
						option.field === "dateOfHire" ||
						option.field === "stubLanguage" ||
						option.field === "emailStub" ||
						option.field === "printHourlyRateOnStub" ||
						option.field === "payMethod" ||
						option.field === "gender" ||
						option.field === "provinceOfEmployment"
					}
				/>
				{showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{ display: "flex", marginLeft: "10px", height: "37px" }}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding:"8px 10px 8px 10px",
								padding: "10px 22px 10px 10px",
								fontSize: ".875rem",
								// marginRight:"-14px!important",
								borderRadius: "0px 2px 2px 0px",
								// backgroundColor: theme.palette.primary.main
							}}
						>
							{/* <SearchIcon /> */}
							Search
						</Button>
					</span>
				)}
				{/* {selectedItems.length > 0 ?
                        (
                          <>
                        <Button
                          icon="pi pi-trash"
                          onClick={() =>
                            onRowDeleteClicked(selectedItems)
                          }
                          severity="danger"
                        />
                          </>
                        ):(<></>)} */}
				{/* {selectionToolbar && selectionToolbar(selectedItemsIds)} */}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.clientName.props.children
						.toLowerCase()
						.indexOf(itemSearsch.toLowerCase()) > -1
			)
		);
	}
	// Custom column for row indices
	const indexColumn = {
		body: (rowData: any, row: any) => {
			return <span>{row.rowIndex + 1}</span>; // +1 to start indexing from 1 instead of 0
		},
		header: "#",
	};

	// const onPage = (event: any) => {
	// 	// setRequestParams(event);
	// 	setLoading(true);
	// 	//imitate delay of a backend call
	// 	setTimeout(() => {
	// 		setRequestParams({
	// 			...event,
	// 			searchQuery: itemSearch,
	// 		});
	// 		setLoading(false);
	// 	}, 1000);
	// };

	// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
	// const onPage = (event: any) => {
	// 	// setRequestParams(event);
	// 	setLoading(true)
	// 	//imitate delay of a backend call
	// 	// setTimeout(() => {
	// 	setRequestParams({
	// 		...event,
	// 		searchQuery: itemSearch,
	// 	});
	// 	if (onRequestParamsChange) {
	// 		onRequestParamsChange({
	// 			...event,
	// 			searchQuery: itemSearch,
	// 		});
	// 	}
	// 	//   setLoading(false);
	// 	// }, 1000);
	// };

	const onPage = (event: any) => {
		setRequestParams({
			...event,
			searchQuery: itemSearch,
		});
		// no direct onRequestParamsChange call here — the effect handles it
	};

	const onColReorder = (event: any) => {
		// setLoading(true);
		// setTimeout(() => {
		// 	setRequestParams({
		// 		...event,
		// 		searchQuery: itemSearch,
		// 	});
		// 	setLoading(false);
		// }, 1000);

		// bcz of selection columns -1 added
		const dragIndex = event.dragIndex - 1; // adjust for selection column
		const dropIndex = event.dropIndex - 1;

		// If the user dragged the selection column (which shouldn't be reorderable), skip
		// if (dragIndex === dropIndex) return; // no change
		if (dragIndex < 0 || dropIndex < 0 || dragIndex === dropIndex) return;

		// Clone and reorder headerColumns
		const updatedColumns = [...columns];
		const [movedItem] = updatedColumns.splice(dragIndex, 1);
		updatedColumns.splice(dropIndex, 0, movedItem);
		// Reassign sequence numbers
		const reSequenced = updatedColumns.map((col, idx) => ({
			...col,
			sequence: idx,
		}));

		onColumnReorder(reSequenced);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				// Toggle sortOrder between 1 and -1
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				// Set the new sortField and reset sortOrder to 1
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}


			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
			// if (onRequestParamsChange) {
			// 	onRequestParamsChange({
			// 		first: requestParams.first,
			// 		page: requestParams.page,
			// 		rows: requestParams.rows,
			// 		searchQuery: requestParams.searchQuery,
			// 		sortOrder: newSortOrder !== 1 ? "asc" : "desc",
			// 		sortField: event.sortField,
			// 	});
			// }

			// // Imitate delay of a backend call
			// setTimeout(() => {
			// 	setLoading(false);
			// }, 1000);
		},
		[sortOrder, sortField]
	);
	// // This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
	// useEffect(() => {
	// 	// if the results fetcher was passed, we can use it to fetch the results.
	// 	if (onRequestParamsChange) {
	// 		// skip the first initial call
	// 		if (isInitialRequest.current === true) {

	// 			isInitialRequest.current = false;
	// 		} else {

	// 			onRequestParamsChange(requestParams);
	// 		}
	// 	}
	// }, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (onRequestParamsChange) {
			if (isInitialRequest.current === true) {
				isInitialRequest.current = false;
			} else {
				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});

		}

	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			// setSelectedItems(selectedItemsIds);
			// Check for deleted items and remove them from selectedItems
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedAuditEarningsItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);

				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);
	useEffect(() => {
		// Check for deleted items and remove them from selectedItems
		const updatedSelectedItems =
			selectedItems &&
			selectedItems.length > 0 &&
			selectedItems.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
		// Only update if there are changes to selectedItems
		if (
			updatedSelectedItems &&
			updatedSelectedItems.length !== selectedItems.length
		) {
			setSelectedItems(updatedSelectedItems);

			// Update selectedItemsIds
			const updatedSelectedItemsIds = updatedSelectedItems.map(
				(item: any) => item.id
			);
			setSelectedItemsIds(updatedSelectedItemsIds);
		}

		// // after update ignore tag in table then check whether new data is same as presvios selected items
		// const updatedSelectedAuditEarningsItems =
		// 	selectedAuditEarningsItems &&
		// 	selectedAuditEarningsItems.length > 0 &&
		// 	selectedAuditEarningsItems.filter((selectedItem: any) => {
		// 		return rows && rows.find((row: any) => row === selectedItem);
		// 	});
		// // Only update if there are changes to selectedItems
		// if (
		// 	updatedSelectedAuditEarningsItems &&
		// 	updatedSelectedAuditEarningsItems.length !== selectedItems.length
		// ) {
		// 	setSelectedItems(updatedSelectedAuditEarningsItems);

		// 	// Update selectedItemsIds
		// 	const updatedSelectedAuditEarningsItemsIds =
		// 		updatedSelectedAuditEarningsItems.map((item: any) => item.id);
		// 	setSelectedItemsIds(updatedSelectedAuditEarningsItemsIds);
		// }

	}, [rows, selectedItems, selectedAuditEarningsItems]);

	// const onCellValueChange = (event: any, rowIndex: number, field: any) => {
	// 	setEmployeeListData((prev: any) => {
	// 		const updatedData = [...prev];
	// 		const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
	// 		updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
	// 		return updatedData;
	// 	});
	// };
	// const renderErrorClass = (
	// 	field: { field: string },
	// 	rowIndex: number,
	// 	rowData: any
	// ): string => {
	// 	const fieldName = field?.field;

	// 	const isInvalid =
	// 		fieldName === "socialInsuranceNumber" &&
	// 		(!selectedItems?.[rowIndex]?.[fieldName] ||
	// 			selectedItems[rowIndex][fieldName].trim() === "");

	// 			
	// 	if (isInvalid) {
	// 		// Remove alert — it's not user-friendly for validation indicators
	// 		return "error-input p-component p-filled input-dropdown-fields";
	// 	}

	// 	return "p-component p-filled input-dropdown-fields";
	// };

	// const columnsBody = (rowData: any, row: any, x: any) => {
	// 	// province of employement DDL
	// 	const [provinceOfEmployementDDL, setprovinceOfEmployementDDL] =
	// 		useState<any>(undefined);
	// 	useEffect(() => {
	// 		if (countryList && Array.isArray(countryList)) {
	// 			const canada = countryList.find(
	// 				(item: any) => item.label === "Canada" || "canada"
	// 			);
	// 			if (canada) {
	// 				(async () => {
	// 					try {
	// 						const response = await CountryService.getProvinceOrStateDDL(
	// 							navigateToLogout,
	// 							canada.value,
	// 							"Province"
	// 						);
	// 					
	// 						setprovinceOfEmployementDDL(response);
	// 					} catch (err) {
	// 						console.error("error", err);
	// 					}
	// 				})();
	// 			} else {
	// 				setprovinceOfEmployementDDL(undefined);
	// 			}
	// 		}
	// 	}, [countryList]);

	// 	if (x.field === "firstName") {
	// 		return (
	// 			<InputText
	// 				value={rowData[x.field]}
	// 				onChange={(e: any) =>
	// 					onCellValueChange(x, row.rowIndex, e.target.value)
	// 				}
	// 				className={renderErrorClass(x, row.rowIndex, rowData)}
	// 				style={{ maxWidth: "12rem" }}
	// 			/>
	// 		);
	// 	} else if (x.field === "lastName") {
	// 		return (
	// 			<InputText
	// 				value={rowData[x.field]}
	// 				onChange={(e: any) =>
	// 					onCellValueChange(x, row.rowIndex, e.target.value)
	// 				}
	// 				className={renderErrorClass(x, row.rowIndex, rowData)}
	// 				style={{ maxWidth: "12rem" }}
	// 			/>
	// 		);
	// 	} else if (x.field === "provinceOfEmployment") {
	// 		return (
	// 			<Dropdown
	// 				options={provinceOfEmployementDDL ?? []}
	// 				value={rowData.provinceOfEmployment}
	// 				onChange={(e: any) =>
	// 					onCellValueChange(x, row.rowIndex, e.target.value)
	// 				}
	// 				placeholder="--"
	// 				className={renderErrorClass(x, row.rowIndex, rowData)}
	// 			/>
	// 		);
	// 	} else {
	// 		return <span>{rowData[x.field]}</span>;
	// 	}
	// };

	// const onCellEditComplete = (e: any) => {
	// 	let { rowData, newValue, field, originalEvent: event } = e;

	// 	switch (field) {
	// 		// case 'quantity':
	// 		// case 'price':
	// 		//     if (isPositiveInteger(newValue)) rowData[field] = newValue;
	// 		//     else event.preventDefault();
	// 		//     break;

	// 		case "provinceOfEmployment":
	// 			rowData[field] = newValue;
	// 			break;
	// 		case "dateOfHire":
	// 			rowData[field] = formatDate(newValue);
	// 			break;
	// 		default:
	// 			if (newValue.trim().length > 0) rowData[field] = newValue;
	// 			else event.preventDefault();
	// 			break;
	// 	}
	// 	
	// };

	const onCellEditComplete = (e: any) => {
		const { rowData, newValue, field, originalEvent: event } = e;

		// Handle required field validation
		if (
			newValue === null ||
			(typeof newValue === "string" && newValue.trim().length === 0)
		) {
			event.preventDefault();
			return;
		}

		// Fields that can be assigned directly
		const directFields = new Set([
			"employeeId",
			"firstName",
			"lastName",
			"initial",
			"addressLine1",
			"email",
			"city",
			"vacationPayOpenBalance",
			"provinceOfEmployment",
			"gender",
			"country",
			"province",
			"postCode",
			"zipCode",
			"stubLanguage",
			"emailStub",
			"printHourlyRateOnStub",
			"payFrequency",
			"payMethod",
			"includeInT4OrRl1",
			"vacationPay",
			"payOutVacationPay",
			"dentalBenefits",
		]);

		if (directFields.has(field)) {
			rowData[field] = newValue;
		} else if (field === "dateOfHire") {
			rowData[field] = formatDate(newValue);
		} else if (field === "socialInsuranceNumber") {
			rowData[field] = addDashesInSIN(newValue);
		} else if (field === "phone") {
			rowData[field] = formatPhoneNo(newValue);
		}

		setEmployeeListItems((prev: any[]) => [...prev]);
	};

	const cellEditor = (options: any) => {
		if (options.field === "employeeId") return textEditor(options);
		if (options.field === "firstName") return textEditor(options);
		if (options.field === "lastName") return textEditor(options);
		if (options.field === "initial") return textEditorForInitial(options);
		if (options.field === "gender") return genderDdlEditor(options);
		if (options.field === "socialInsuranceNumber")
			return socialInsuranceNumberFieldEditor(options);
		if (options.field === "addressLine1") return textEditor(options);
		if (options.field === "email") return textEditor(options);
		if (options.field === "phone") return phoneNumberFieldEditor(options);
		// if (options.field === "country") return countryDDLFieldEditor(options);
		if (options.field === "province") return provinceDdlEditor(options);
		if (options.field === "city") return textEditor(options);
		if (options.field === "postCode")
			return postalCodeNumberFieldEditor(options);
		if (options.field === "zipCode") return zipCodeNumberFieldEditor(options);
		if (options.field === "stubLanguage") return stubLanguageDdlEditor(options);
		if (options.field === "emailStub") return emailStubDdlEditor(options);
		if (options.field === "printHourlyRateOnStub")
			return printHourlyRateOnStubDdlEditor(options);
		// if (options.field === "payFrequency") return payFrequencyDdlEditor(options);
		if (options.field === "payMethod" && companyInformation && companyInformation.paymentSetup !== 100) return payMethodDdlEditor(options);
		if (options.field === "provinceOfEmployment") return poeDdlEditor(options);
		if (options.field === "country") return countryDdlEditor(options);
		if (options.field === "includeInT4OrRl1")
			return includeInT4OrRl1DdlEditor(options);
		if (options.field === "vacationPay") return vacationPayDdlEditor(options);
		if (options.field === "dentalBenefits")
			return dentalBenefitsDdlEditor(options);
		if (options.field === "payOutVacationPay")
			return payOutVacationPayDdlEditor(options);
		if (options.field === "vacationPayOpenBalance")
			return vacationPayOpenBalanceEditor(options);
		else return <span>{options.value}</span>;
		// else return textEditor(options);
	};

	const textEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputText
				value={options.value}
				onChange={handleChange}
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "180px" }}
			/>
		);
	};
	const textEditorForInitial = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputText
				value={options.value}
				onChange={handleChange}
				onKeyDown={(e) => e.stopPropagation()}
				maxLength={3}
			/>
		);
	};

	const socialInsuranceNumberFieldEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: any) => {
			const value = e.target.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputMask
				value={options.value}
				onChange={handleChange}
				onKeyDown={(e) => e.stopPropagation()}
				mask="999-999-999"
				unmask={true}
				autoClear={false}
			// className={renderErrorClass(options.column, options.rowIndex, rowData)}
			/>
		);
	};

	const phoneNumberFieldEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: any) => {
			const value = e.target.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputMask
				value={options.value}
				onChange={handleChange}
				onKeyDown={(e) => e.stopPropagation()}
				mask="(999) 999-9999"
				unmask={true}
				autoClear={false}
			/>
		);
	};
	// const SocialInsuranceNumberInput = ({
	// 	rowData,
	// 	field,
	// 	editorCallback,
	// }: any) => {
	// 	const [formattedValue, setFormattedValue] = useState(() =>
	// 		addDashesInSIN(rowData[field])
	// 	);

	// 	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	// 		const value = e.target.value;

	// 		setEmployeeListItems((prev: any[]) => {
	// 			const updated = [...prev];
	// 			const index = updated.findIndex((item) => item.id === rowData.id);
	// 			if (index !== -1) {
	// 				updated[index] = { ...updated[index], [field]: value };
	// 			}
	// 			return updated;
	// 		});

	// 		editorCallback(value);
	// 		setFormattedValue(addDashesInSIN(value));
	// 	};

	// 	return (
	// 		<InputText
	// 			value={formattedValue}
	// 			onChange={handleChange}
	// 			onKeyDown={(e) => e.stopPropagation()}
	// 			maxLength={11}
	// 		/>
	// 	);
	// };

	// // In your DataTable column, use the component in the `editor` prop
	// const socialInsuranceNumberFieldEditor = (options: any) => {
	// 	return (
	// 		<SocialInsuranceNumberInput
	// 			rowData={options.rowData}
	// 			field={options.field}
	// 			editorCallback={options.editorCallback}
	// 		/>
	// 	);
	// };

	const genderDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Male", value: 200 },
					{ label: "Female", value: 100 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const stubLanguageDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "English", value: 100 },
					{ label: "French", value: 200 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const emailStubDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const printHourlyRateOnStubDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const payFrequencyDdlEditor = (options: any) => {
		const frequencyIdGetByFrequencyLabel = getDDLValueByLabel(payFrequencyDDLItems, options.value);
		options.value = frequencyIdGetByFrequencyLabel

		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={payFrequencyDDLItems ?? []}
				value={options.value}
				onChange={onChange}
				// placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const payMethodDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Cheque", value: 200 },
					{ label: "Direct Deposit", value: 300 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const includeInT4OrRl1DdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const vacationPayDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Calculate", value: 100 },
					{ label: "Disable", value: 200 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const dentalBenefitsDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Not eligible", value: 100 },
					{ label: "Payee only", value: 200 },
					{ label: "Payee, Spouse, Children", value: 300 },
					{ label: "Payee, Spouse", value: 400 },
					{ label: "Payee, Children", value: 500 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const payOutVacationPayDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	const vacationPayOpenBalanceEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: any) => {
			const value = e.target.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			// <InputText
			// 	value={options.value}
			// 	onChange={handleChange}
			// 	onKeyDown={(e) => e.stopPropagation()}
			// 	maxLength={3}
			// />
			<InputNumber
				value={options.value}
				onChange={handleChange}
				placeholder="0.00"
				minFractionDigits={2}
				maxFractionDigits={2}
				inputStyle={{ textAlign: "right" }}
			/>
		);
	};
	const [provinceDDL, setProvinceDDL] = useState(undefined);
	const provinceDdlEditor = (options: any) => {
		const { rowData, field } = options;
		(async () => {
			try {
				const response = await CountryService.getProvinceOrStateDDL(
					navigateToLogout,
					rowData.country && rowData.country !== null && rowData.country,
					"Province"
				);

				setProvinceDDL(response);
			} catch (err) {
				console.error("error", err);
			}
		})();

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={provinceDDL && provinceDDL}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};
	// const countryDDLFieldEditor = (options: any) => {
	// 	const { rowData, field } = options;

	// 	const onChange = (e: any) => {
	// 		const newValue = e.value;

	// 		setEmployeeListItems((prev: any[]) => {
	// 			const updated = [...prev];
	// 			const index = updated.findIndex((item) => item.id === rowData.id);
	// 			if (index !== -1) {
	// 				updated[index] = { ...updated[index], [field]: newValue };
	// 			}
	// 			return updated;
	// 		});

	// 		options.editorCallback(newValue);
	// 	};
	// 	return (
	// 		<Dropdown
	// 			options={countryList}
	// 			value={options.value}
	// 			onChange={onChange}
	// 			placeholder="--"
	// 			onKeyDown={(e) => e.stopPropagation()}
	// 			style={{ width: "100%" }}
	// 			disabled={!provinceOfEmployementDDL}
	// 		/>
	// 	);
	// };

	const postalCodeNumberFieldEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: any) => {
			const value = e.target.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputMask
				value={options.value}
				onChange={handleChange}
				onKeyDown={(e) => e.stopPropagation()}
				mask="a9a9a9"
				unmask={true}
				autoClear={false}
				style={{ textTransform: "uppercase" }}
			/>
		);
	};

	const zipCodeNumberFieldEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: any) => {
			const value = e.target.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputMask
				value={options.value}
				onChange={handleChange}
				onKeyDown={(e) => e.stopPropagation()}
				mask="00000"
				unmask={true}
				autoClear={false}
			/>
		);
	};

	const poeDdlEditor = (options: any) => {
		const { rowData, field } = options;
		const poeIdGetByPoeLabel = getProvinceDDLValueByShortCode(provinceOfEmployementDDL, options.value);
		options.value = poeIdGetByPoeLabel

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={provinceOfEmployementDDL || []}
				value={options.value}
				onChange={onChange}
				// placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
				disabled={!provinceOfEmployementDDL}
			/>
		);
	};

	const countryDdlEditor = (options: any) => {
		const { rowData, field } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: newValue };
				}
				return updated;
			});

			options.editorCallback(newValue);
		};
		return (
			<Dropdown
				options={countryList || []}
				value={options.value}
				onChange={onChange}
				placeholder="--"
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
				disabled={!countryList}
			/>
		);
	};

	const DateEditor = (options: any) => {
		const handleChange = (e: any) => {
			const newDate = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex(
					(item) => item.id === options.rowData.id
				);
				if (index !== -1) {
					updated[index] = { ...updated[index], chequeDate: newDate };
				}
				return updated;
			});

			options.editorCallback(newDate);
		};

		return (
			<div onClick={(e) => e.stopPropagation()}>
				<Calendar
					value={options.value}
					onChange={handleChange}
					dateFormat="M dd, yy"
					showButtonBar
					placeholder="M dd, yyyy"
				/>
			</div>
		);
	};

	const NumberFieldEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: any) => {
			const value = e.value;

			setEmployeeListItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputNumber
				value={options.value}
				onChange={handleChange}
				placeholder="0.00"
				minFractionDigits={2}
				maxFractionDigits={2}
				inputStyle={{ textAlign: "right" }}
			/>
		);
	};
	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "provinceOfEmployment") {
			const selected = provinceOfEmployementDDL?.find(
				(item: { value: any }) => item.value === rowData[x.field]
			);
			return selected ? selected.label : rowData[x.field];
		} else if (x.field === "country") {
			const selected = countryList?.find(
				(item: { value: any }) => item.value === rowData[x.field]
			);
			return selected ? selected.label : rowData[x.field];
		} else if (x.field === "socialInsuranceNumber") {
			return rowData[x.field]?.charAt(2) === "*" ? "Unmask to view / edit" : addDashesInSIN(rowData[x.field]);
		}
		else if (x.field === "email") {
			return rowData[x.field]?.charAt(2) === "*" ? "Unmask to view / edit " : rowData[x.field];
		}
		else if (x.field === "province") {
			const selected = provinceOfEmployementDDL?.find(
				(item: { value: any }) => item.value === rowData[x.field] && rowData[x.field]
			);
			return selected ? selected.label : rowData[x.field];
		} else if (x.field === "dateOfHire" || x.field === "dateOfBirth") {
			return rowData[x.field] && rowData[x.field]?.charAt(2) === "*" ? "Unmask to view" : rowData[x.field];
		} else if (x.field === "split") {
			return rowData[x.field] === 100
				? "No Split"
				: rowData[x.field] === 200
					? "Percentage"
					: "Fixed Amount";
		} else if (x.field === "gender") {
			return rowData[x.field] === 200 ? "Male" : "Female";
		} else if (x.field === "payFrequency") {
			return getDDLLabelByValue(payFrequencyDDLItems, rowData[x.field]);
			// return rowData[x.field];
		} else if (x.field === "payMethod") {
			return companyInformation && companyInformation.paymentSetup === 100 ? "Cheque" : rowData[x.field] === 100 ? "Cash" : rowData[x.field] === 200 ? "Cheque" : rowData[x.field] === 300 ? "Direct Deposit" : "";
		} else if (x.field === "vacationPay") {
			return rowData[x.field] === 100 ? "Calculate" : "Disable";
		} else if (x.field === "payOutVacationPay") {
			return rowData[x.field] === 100 ? "No" : "Yes";
		} else if (x.field === "includeInT4OrRl1") {
			return rowData[x.field] === 100 ? "No" : "Yes";
		} else if (x.field === "dentalBenefits") {
			return rowData[x.field] === 100
				? "Not eligible"
				: rowData[x.field] === 200
					? "Payee only"
					: rowData[x.field] === 300
						? "Payee, Spouse, Children"
						: rowData[x.field] === 400
							? "Payee, Spouse"
							: "Payee, Children";
		} else if (x.field === "sinStatus") {
			return rowData[x.field] === 100
				? "Pending"
				: rowData[x.field] === 200
					? "Refused"
					: rowData[x.field] === 300
						? "Failed to Provide"
						: rowData[x.field] === 400
							? "Recorded"
							: "Recorded Incorrect";
		} else if (x.field === "stubLanguage") {
			return rowData[x.field] === 100 ? "English" : "French";
		} else if (x.field === "emailStub") {
			return rowData[x.field] === 100 ? "No" : "Yes";
		} else if (x.field === "printHourlyRateOnStub") {
			return rowData[x.field] === 100 ? "No" : "Yes";
		} else if (x.field === "vacationPayOpenBalance") {
			return parseFloat(rowData[x.field])
				.toFixed(2)
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		} else return <span>{rowData[x.field]}</span>;
	};

	// ─── STICKY HEADER ──────────────────────────────────────────────────────
	// All the DOM-cloning logic now lives in the shared hook. This page only
	// supplies what's specific to it: nothing, in this case, since the
	// defaults already match this table's class names (.p-frozen-column /
	// .selectionHeader) and styling (navbar height 112, #0091b3 header text).
	// Other pages can override any of these without touching the hook.
	const containerRef = useStickyDataTableHeader<HTMLDivElement>(
		[columns],
		{
			navbarHeight: 112,
			// navbarHeight: mobileTabOrSmallLaptopScreen ? 64 : 112,
			// This page's frozen columns use PrimeReact's own frozen class plus
			// the local "selectionHeader" class for the checkbox column.
			frozenColumnSelector: ".p-frozen-column, .selectionHeader",
			selectionHeaderSelector: ".selectionHeader",
		}
	);

	// return isLoading ? (
	// 	<SkeletonLoadingDataGrid pageTitle={pageTitle} />
	// ) : (
	return (
		<>
			{/* {rows && provinceOfEmployementDDL && payFrequencyDDLItems ? ( */}
			{rows && provinceOfEmployementDDL ? (
				<div
					ref={mobileTabOrSmallLaptopScreen ? null : containerRef}
				// style={{
				// 	width: "100%",
				// 	overflow: "hidden", // container stays fixed
				// 	background: "#fff"
				// }}
				>
					<DataTable
						value={
							rows &&
							columns &&
							visibleColumns.length > 0 &&
							rows &&
							employeeListItems
							// employeeListData
						}
						responsiveLayout="scroll"
						lazy
						// filterDisplay="row"
						dataKey="id"
						paginator
						first={requestParams.first}
						rows={requestParams.rows}
						totalRecords={totalRecords}
						onPage={onPage}
						rowsPerPageOptions={rowsPerPageOptions}
						paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
						currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
						selection={selectedItems}
						onSelectionChange={onSelectionModelChange}
						editMode="cell"
						selectionMode={"checkbox"}
						// selectionMode="multiple"
						showGridlines
						resizableColumns
						columnResizeMode="expand"
						scrollable
						scrollHeight={tableScrollHeight ? "75vh" : ""}
						// scrollHeight="450px"
						// reorderableColumns
						onColReorder={onColReorder}
						// filterDisplay="menu"
						// loading={isLoading ? isLoading : loading}
						// globalFilterFields={["headerName"]}
						header={searchFieldPlaceholder ? headerSearch : undefined}
						footer={footer ? footer : undefined}
						emptyMessage={rows && rows.length === 0 ? "No Record Found." : "Loading..."}
						className="PrimeDataGridWithColumnToggled"
						style={{
							margin: `${tableMargin ? tableMargin : "14px 0 0.5rem 0"}`,
						}}
						sortMode="single"
						onSort={onSort}
					>
						{columns && visibleColumns.length > 0 && rows && rows.length > 0 && (
							<Column
								selectionMode="multiple"
								hidden={!showChecboxColumn}
								frozen
								resizeable={false}
								style={{ width: "36px", textAlign: "center" }}
								field="selection"
								alignFrozen="left"
								columnKey="selection"
								className="selectionHeader"
								headerClassName="selectionHeader"
							></Column>
						)}
						{rows && rows.length ? (
							<Column
								body={editColumn}
								// header={setting}
								style={{ width: "36px" }}
								hidden={!showSettingColumn}
								resizeable={false}
								reorderable={false}
								frozen
								alignFrozen="left"
								// className="settingHeader"
								headerClassName="settingHeader"
							></Column>
						) : undefined}

						{rows && rows.length ? (
							<Column
								header="#"
								className="indexColumn"
								headerClassName="indexColumn"
								headerStyle={{ width: "24px" }}
								frozen
								hidden={!showIndexColumn}
								body={(data, options) => options.rowIndex + 1}
							></Column>
						) : undefined}

						{columns &&
							columns
								.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
								.map((x: any, index: any) => {
									const editableFields = new Set([
										"employeeId",
										"firstName",
										"lastName",
										"initial",
										"gender",
										"socialInsuranceNumber",
										"addressLine1",
										"email",
										"phone",
										"country",
										"province",
										"city",
										"postCode",
										"zipCode",
										"stubLanguage",
										"emailStub",
										"printHourlyRateOnStub",
										// "payFrequency",
										"payMethod",
										"provinceOfEmployment",
										"includeInT4OrRl1",
										"vacationPay",
										"dentalBenefits",
										"payOutVacationPay",
										"vacationPayOpenBalance",
									]);
									if (companyInformation?.paymentSetup === 100) {
										editableFields.delete("payMethod");
									}
									if (maskStatus) {
										editableFields.delete("socialInsuranceNumber");
										editableFields.delete("email");
									}

									return (
										<Column
											key={index}
											field={x.field}
											header={x.headerName}
											// headerTooltip={disabledHeaderTooltip ? "" : x.description}
											headerTooltipOptions={{ position: "top" }}
											hidden={x.hide}
											sortable={x.sortable}
											// resizable={x.resizable}
											dataType={x.type}
											align={x.align}
											alignHeader={x.headerAlign}
											// reorderable={x.disableReorder}
											exportable={x.disableExport}
											frozen={x.frozenColumn}
											alignFrozen={x.alignFrozen}
											columnKey={x.field}
											// sequence={x.sequence}
											style={{
												minWidth: x.minWidth,
												fontSize: "0.875rem",
												maxWidth: x.maxWidth,
											}}
											headerStyle={{
												whiteSpace: whiteSpace ? whiteSpace : "nowrap",
											}}
											footer={x.footer}
											// body={(rowData: any, row: any) =>
											// 	columnsBody(rowData, row, x)
											// }
											editor={
												editableFields.has(x.field) ? cellEditor : undefined
											}
											onCellEditComplete={onCellEditComplete}
											body={(rowData: any, row: any) =>
												columnsBody(rowData, row, x)
											}
										/>
									);
								})}

						{rows && rows.length ? (
							<Column
								body={deleteRowColumn}
								// header={setting}
								style={{
									width: "36px",
									position: exportButtonInFileList ? "relative" : "sticky",
									overflow: exportButtonInFileList ? "visible" : "hidden",
								}}
								hidden={!showSettingColumn}
								resizeable={false}
								reorderable={false}
								frozen
								alignFrozen="right"
								className="settingHeader"
								headerClassName="settingHeader"
							></Column>
						) : undefined}
					</DataTable></div>
			) : (
				// <div style={{ display: "flex", alignItems: "center" }}>
				// 	<p>Data is loading...</p>&nbsp;&nbsp;
				// 	<CircularProgress sx={{ maxHeight: "15px", maxWidth: "15px" }} />
				// </div>

				// <></>

				<p>Data is loading...</p>
			)}
		</>
	);
};



// import "./PrimeDataGridWithColumnToggledStyle.css";
// import {
// 	BackdropCircularProgress,
// 	RequestParams,
// } from "@websential/cosmic-v20";
// import { Box, CircularProgress, useTheme } from "@mui/material";
// import {
// 	EnhancedButtonPrimeReactSeverity,
// 	addDashesInSIN,
// 	formatDate,
// 	formatDateToShow,
// 	formatPhoneNo,
// 	getDDLLabelByValue,
// 	getDDLValueByLabel,
// 	getProvinceDDLValueByShortCode,
// 	useNavigateToLogout,
// } from "../../common/Common";
// import { GridRenderCellParams, GridRowSelectionModel } from "@mui/x-data-grid";
// import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

// import { Button } from "primereact/button";
// import { Calendar } from "primereact/calendar";
// import { Card } from "primereact/card";
// import { Column } from "primereact/column";
// import { CountryService } from "../../services/common/CountryService";
// import { DataTable } from "primereact/datatable";
// import { Dropdown } from "primereact/dropdown";
// import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
// import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// import { IAppState } from "../../store/reducers";
// import { InputMask } from "primereact/inputmask";
// import { InputNumber } from "primereact/inputnumber";
// import { InputText } from "primereact/inputtext";
// import { MultiSelect } from "primereact/multiselect";
// import SearchIcon from "@mui/icons-material/Search";
// import { useSelector } from "react-redux";
// import { useStickyDataTableHeader } from "../../common/useStickyDataTableHeader";

// export interface IDataTable {
// 	rows: any;
// 	columns: any;
// 	completeHeaderColumnsList: any;
// 	submitAddRemoveColumnsHandler: (value: any) => void;
// 	onColumnReorder: (value: any) => void;
// 	showIndexColumn: boolean;
// 	showChecboxColumn: boolean;
// 	showSettingColumn: boolean;
// 	onRowDeleteClicked?: (params: any) => void;
// 	onRowEditClicked?: (params: any) => void;
// 	isLoading?: any;
// 	onSnackbarMessageData?: (value: any) => void;
// 	onRequestParamsChange?: (params: any) => void;
// 	initialPageSize?: number | undefined;
// 	initialPage?: number;
// 	totalRecords?: number;
// 	selectionToolbar?: (selectedItems: any) => React.ReactNode;
// 	selectedRowsValues?: any;
// 	changeLoginForGetEmptyItemsBySearchQuery?: any;
// 	searchFieldPlaceholder?: string;
// 	showGlobalSearch?: boolean;
// 	tableMargin?: string;
// 	rowsPerPageOptions?: number[];
// 	footer?: any;
// 	cardHeaderTitle?: string;
// 	cardHeaderSubTitle?: string;
// 	disabledHeaderTooltip?: boolean;
// 	viewIcon?: boolean;
// 	whiteSpace?: string;
// 	exportButton?: boolean;
// 	exportButtonLabel?: string;
// 	exportButtonInFileList?: boolean;
// 	onExportButtonClick?: (event: string, params: any) => void;
// 	onExportButtonInFileListClick?: (event: string, params: any) => void;
// 	requestParamsToInitial?: boolean;
// 	tableScrollHeight?: boolean;
// 	pageTitle?: string;
// 	provinceOfEmployementDDL?: any;
// 	countryList?: any;
// 	provinceOrStateDDL?: any;
// 	employeeListTableData: (data: any) => void;
// 	payFrequencyDDLItems?: any;
// 	companyInformation?: any;
// 	maskStatus?: any;
// }
 
// // Fields that are always pinned / non-toggleable. Declared once, outside the
// // component, since the contents never change at runtime.
// const FIXED_COLUMN_FIELDS = [
// 	"firstName",
// 	"lastName",
// 	"dateOfBirth",
// 	"addressLine1",
// 	"country",
// 	"province",
// 	"city",
// 	"postCode",
// 	"dateOfHire",
// 	"stubLanguage",
// 	"emailStub",
// 	"printHourlyRateOnStub",
// 	"payMethod",
// 	"gender",
// 	"provinceOfEmployment",
// ];
// const FIXED_COLUMN_FIELDS_SET = new Set(FIXED_COLUMN_FIELDS);
 
// const BASE_EDITABLE_FIELDS = [
// 	"employeeId",
// 	"firstName",
// 	"lastName",
// 	"initial",
// 	"gender",
// 	"socialInsuranceNumber",
// 	"addressLine1",
// 	"email",
// 	"phone",
// 	"country",
// 	"province",
// 	"city",
// 	"postCode",
// 	"zipCode",
// 	"stubLanguage",
// 	"emailStub",
// 	"printHourlyRateOnStub",
// 	"payMethod",
// 	"provinceOfEmployment",
// 	"includeInT4OrRl1",
// 	"vacationPay",
// 	"dentalBenefits",
// 	"payOutVacationPay",
// 	"vacationPayOpenBalance",
// ];
 
// const DIRECT_ASSIGN_FIELDS = new Set([
// 	"employeeId",
// 	"firstName",
// 	"lastName",
// 	"initial",
// 	"addressLine1",
// 	"email",
// 	"city",
// 	"vacationPayOpenBalance",
// 	"provinceOfEmployment",
// 	"gender",
// 	"country",
// 	"province",
// 	"postCode",
// 	"zipCode",
// 	"stubLanguage",
// 	"emailStub",
// 	"printHourlyRateOnStub",
// 	"payFrequency",
// 	"payMethod",
// 	"includeInT4OrRl1",
// 	"vacationPay",
// 	"payOutVacationPay",
// 	"dentalBenefits",
// ]);
 
// const GENDER_OPTIONS = [
// 	{ label: "Male", value: 200 },
// 	{ label: "Female", value: 100 },
// ];
// const STUB_LANGUAGE_OPTIONS = [
// 	{ label: "English", value: 100 },
// 	{ label: "French", value: 200 },
// ];
// const YES_NO_200_100_OPTIONS = [
// 	{ label: "Yes", value: 200 },
// 	{ label: "No", value: 100 },
// ];
// const PAY_METHOD_OPTIONS = [
// 	{ label: "Cheque", value: 200 },
// 	{ label: "Direct Deposit", value: 300 },
// ];
// const VACATION_PAY_OPTIONS = [
// 	{ label: "Calculate", value: 100 },
// 	{ label: "Disable", value: 200 },
// ];
// const DENTAL_BENEFITS_OPTIONS = [
// 	{ label: "Not eligible", value: 100 },
// 	{ label: "Payee only", value: 200 },
// 	{ label: "Payee, Spouse, Children", value: 300 },
// 	{ label: "Payee, Spouse", value: 400 },
// 	{ label: "Payee, Children", value: 500 },
// ];
 
// export const PrimeDataGridWithColumnToggled: React.FC<IDataTable> = ({
// 	rows,
// 	columns,
// 	completeHeaderColumnsList,
// 	submitAddRemoveColumnsHandler,
// 	onColumnReorder,
// 	showIndexColumn,
// 	showChecboxColumn,
// 	showSettingColumn,
// 	onRowDeleteClicked,
// 	onRowEditClicked,
// 	isLoading,
// 	onSnackbarMessageData,
// 	onRequestParamsChange,
// 	initialPageSize = 10,
// 	initialPage = 0,
// 	totalRecords,
// 	selectionToolbar,
// 	selectedRowsValues,
// 	searchFieldPlaceholder,
// 	showGlobalSearch = true,
// 	tableMargin,
// 	rowsPerPageOptions,
// 	changeLoginForGetEmptyItemsBySearchQuery,
// 	footer,
// 	cardHeaderTitle,
// 	cardHeaderSubTitle,
// 	disabledHeaderTooltip = false,
// 	viewIcon,
// 	whiteSpace,
// 	exportButton = false,
// 	exportButtonLabel = "file",
// 	exportButtonInFileList = false,
// 	onExportButtonClick,
// 	onExportButtonInFileListClick,
// 	requestParamsToInitial,
// 	tableScrollHeight,
// 	pageTitle,
// 	countryList,
// 	provinceOfEmployementDDL,
// 	employeeListTableData,
// 	payFrequencyDDLItems,
// 	companyInformation,
// 	maskStatus,
// }) => {
// 	const isInitialRequest = useRef(true);
// 	const [loading, setLoading] = useState(false);
// 	const navigateToLogout = useNavigateToLogout();
// 	const [completeHeaderColumnsListState, setCompleteHeaderColumnsListState] =
// 		useState({});
// 	const [columnss, setColumnss] = useState<any>([]);
// 	const [visibleColumns, setVisibleColumns] = useState<any>([]);
// 	const [employeeListItems, setEmployeeListItems] = useState<any>(undefined);
 
// 	// Only swap in a new rows reference when the parent actually gives us a
// 	// new one. React Query already returns a stable reference per fetch, so
// 	// there's no need to deep-compare with JSON.stringify on every render
// 	// (that was re-serializing the entire page of rows on every keystroke).
// 	useEffect(() => {
// 		if (rows) {
// 			setEmployeeListItems(rows);
// 		}
// 	}, [rows]);
 
// 	useEffect(() => {
// 		employeeListTableData(employeeListItems);
// 	}, [employeeListItems]);
 
// 	useEffect(() => {
// 		if (
// 			completeHeaderColumnsList &&
// 			Object.keys(completeHeaderColumnsList).length > 0
// 		) {
// 			setCompleteHeaderColumnsListState(completeHeaderColumnsList);
// 		}
// 	}, [completeHeaderColumnsList]);
 
// 	useEffect(() => {
// 		if (Object.keys(completeHeaderColumnsListState).length > 0) {
// 			const updatedColumns = Object.entries(completeHeaderColumnsListState).map(
// 				([field, status]) => ({
// 					field,
// 					headerName: field
// 						.replace(/([A-Z])/g, " $1")
// 						.replace(/^./, (c) => c.toUpperCase()),
// 					status,
// 				})
// 			);
// 			setColumnss(updatedColumns);
// 			setVisibleColumns(updatedColumns.filter((col) => col.status));
// 		}
// 	}, [completeHeaderColumnsListState]);
 
// 	const [
// 		upadtedCompleteHeaderColumnsList,
// 		setUpadtedCompleteHeaderColumnsList,
// 	] = useState(columnss);
 
// 	const theme = useTheme();
// 	const [itemSearch, setItemSearch] = useState("");
// 	const [requestParams, setRequestParams] = useState<any>({
// 		first: initialPage,
// 		rows: initialPageSize,
// 		page: initialPage,
// 		sortField: null,
// 		sortOrder: "asc",
// 		searchQuery: "",
// 		filters: {
// 			name: { value: "", matchMode: "contains" },
// 			"country.name": { value: "", matchMode: "contains" },
// 			company: { value: "", matchMode: "contains" },
// 			"representative.name": { value: "", matchMode: "contains" },
// 		},
// 	});
 
// 	const [selectedItems, setSelectedItems] = useState<any>([]);
// 	const [selectedAuditEarningsItems, setSelectedAuditEarningsItems] =
// 		useState<any>([]);
// 	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);
 
// 	const editColumn = useCallback(
// 		(params: any) => (
// 			<EnhancedButtonPrimeReact
// 				icon={"pi pi-pencil"}
// 				onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
// 				severity={EnhancedButtonPrimeReactSeverity.Secondary}
// 				className="p-button-rounded p-button-text w-2rem h-2rem"
// 				rounded
// 			/>
// 		),
// 		[onRowEditClicked]
// 	);
 
// 	const deleteRowColumn = useCallback(
// 		(params: any) => (
// 			<EnhancedButtonPrimeReact
// 				icon="pi pi-times"
// 				onClickHandler={() => onRowDeleteClicked && onRowDeleteClicked(params)}
// 				severity={EnhancedButtonPrimeReactSeverity.Danger}
// 				className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
// 				rounded
// 			/>
// 		),
// 		[onRowDeleteClicked]
// 	);
 
// 	const [itemSearsch, setItemSearsch] = useState("");
// 	const onSearchButtonClicked = () => {
// 		setLoading(true);
// 		setRequestParams((prevParams: any) => ({
// 			...prevParams,
// 			first: initialPage,
// 			rows: initialPageSize,
// 			page: initialPage,
// 			searchQuery: itemSearch,
// 		}));
 
// 		if (changeLoginForGetEmptyItemsBySearchQuery) {
// 			changeLoginForGetEmptyItemsBySearchQuery(false);
// 		}
// 		setTimeout(() => setLoading(false), 1000);
// 	};
// 	const handleClearSearch = () => {
// 		setLoading(true);
// 		setItemSearch("");
// 		setRequestParams((prevParams: any) => ({
// 			...prevParams,
// 			first: initialPage,
// 			rows: initialPageSize,
// 			page: initialPage,
// 			searchQuery: "",
// 		}));
 
// 		if (changeLoginForGetEmptyItemsBySearchQuery) {
// 			changeLoginForGetEmptyItemsBySearchQuery(false);
// 		}
// 		setTimeout(() => setLoading(false), 1000);
// 	};
 
// 	const onColumnToggle = (event: any) => {
// 		let selectedColumns = event.value;
// 		let orderedSelectedColumns = columnss.filter(
// 			(col: any) =>
// 				selectedColumns.some((sCol: any) => sCol.field === col.field) ||
// 				FIXED_COLUMN_FIELDS_SET.has(col.field)
// 		);
 
// 		setVisibleColumns(orderedSelectedColumns);
 
// 		const currentColumnsStatus = columnss.map((col: any) => {
// 			const match = orderedSelectedColumns.find(
// 				(selected: { field: any }) => selected.field === col.field
// 			);
// 			return {
// 				...col,
// 				status: match ? true : false,
// 			};
// 		});
// 		setUpadtedCompleteHeaderColumnsList(currentColumnsStatus);
// 	};
 
// 	const onColumnSaveButtonClickedHandler = () => {
// 		const convertArrayToObjectOfAllColumnsFields =
// 			upadtedCompleteHeaderColumnsList.reduce(
// 				(acc: any, { field, status }: any) => ({ ...acc, [field]: status }),
// 				{}
// 			);
 
// 		submitAddRemoveColumnsHandler(convertArrayToObjectOfAllColumnsFields);
// 	};
 
// 	const panelFooterTemplate = () => {
// 		return (
// 			<div
// 				className="py-2 px-3"
// 				style={{
// 					display: "flex",
// 					justifyContent: "end",
// 				}}
// 			>
// 				<EnhancedButtonPrimeReact
// 					label="Save"
// 					raised
// 					severity={EnhancedButtonPrimeReactSeverity.Success}
// 					onClickHandler={onColumnSaveButtonClickedHandler}
// 				/>
// 			</div>
// 		);
// 	};
 
// 	const renderHeader = () => {
// 		return (
// 			<div
// 				style={{
// 					display: "flex",
// 					justifyContent: "space-between",
// 					alignItems: "center",
// 				}}
// 			>
// 				<div
// 					style={{
// 						fontSize: "1.5rem",
// 						fontWeight: "bold",
// 						fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
// 					}}
// 				>
// 					{pageTitle}
// 				</div>
// 				<MultiSelect
// 					value={visibleColumns}
// 					options={columnss}
// 					optionLabel="headerName"
// 					onChange={onColumnToggle}
// 					className="w-full sm:w-20rem"
// 					placeholder="Add/Remove Columns"
// 					maxSelectedLabels={0}
// 					selectedItemsLabel="Add/Remove Columns"
// 					panelFooterTemplate={panelFooterTemplate}
// 					optionDisabled={(option) => FIXED_COLUMN_FIELDS_SET.has(option.field)}
// 				/>
// 				{showGlobalSearch && (
// 					<span
// 						className="p-input-icon-left w-3"
// 						style={{ display: "flex", marginLeft: "10px", height: "37px" }}
// 					>
// 						<i className="pi pi-search" />
// 						<InputText
// 							value={itemSearch}
// 							onChange={(e) => setItemSearch(e.target.value)}
// 							placeholder={
// 								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
// 							}
// 							className="w-full"
// 							style={{ borderRadius: "2px 0px 0px 2px" }}
// 						/>
// 						{itemSearch && (
// 							<Button
// 								icon="pi pi-times"
// 								onClick={handleClearSearch}
// 								className="p-button-warning"
// 								style={{ borderRadius: 0 }}
// 							/>
// 						)}
// 						<Button
// 							onClick={onSearchButtonClicked}
// 							severity={EnhancedButtonPrimeReactSeverity.Secondary}
// 							style={{
// 								padding: "10px 22px 10px 10px",
// 								fontSize: ".875rem",
// 								borderRadius: "0px 2px 2px 0px",
// 							}}
// 						>
// 							Search
// 						</Button>
// 					</span>
// 				)}
// 				{selectionToolbar && selectionToolbar(selectedItems)}
// 			</div>
// 		);
// 	};
// 	const headerSearch = renderHeader();
 
// 	const onPage = (event: any) => {
// 		setRequestParams({
// 			...event,
// 			searchQuery: itemSearch,
// 		});
// 	};
 
// 	const onColReorder = (event: any) => {
// 		const dragIndex = event.dragIndex - 1; // adjust for selection column
// 		const dropIndex = event.dropIndex - 1;
 
// 		if (dragIndex < 0 || dropIndex < 0 || dragIndex === dropIndex) return;
 
// 		const updatedColumns = [...columns];
// 		const [movedItem] = updatedColumns.splice(dragIndex, 1);
// 		updatedColumns.splice(dropIndex, 0, movedItem);
// 		const reSequenced = updatedColumns.map((col, idx) => ({
// 			...col,
// 			sequence: idx,
// 		}));
 
// 		onColumnReorder(reSequenced);
// 	};
 
// 	const [sortField, setSortField] = useState(null);
// 	const [sortOrder, setSortOrder] = useState(1);
// 	const onSort = useCallback(
// 		(event: any) => {
// 			setLoading(true);
 
// 			let newSortOrder: any;
// 			if (event.sortField === sortField) {
// 				newSortOrder = sortOrder === 1 ? -1 : 1;
// 				setSortOrder(newSortOrder);
// 			} else {
// 				newSortOrder = 1;
// 				setSortField(event.sortField);
// 				setSortOrder(newSortOrder);
// 			}
 
// 			setRequestParams((prevParams: any) => ({
// 				...prevParams,
// 				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
// 				sortField: event.sortField,
// 			}));
// 		},
// 		[sortOrder, sortField]
// 	);
 
// 	useEffect(() => {
// 		if (onRequestParamsChange) {
// 			if (isInitialRequest.current === true) {
// 				isInitialRequest.current = false;
// 			} else {
// 				onRequestParamsChange(requestParams);
// 			}
// 		}
// 	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);
 
// 	useEffect(() => {
// 		if (requestParamsToInitial && requestParams.first !== initialPage) {
// 			setRequestParams({
// 				first: initialPage,
// 				rows: initialPageSize,
// 				page: initialPage,
// 				sortField: null,
// 				sortOrder: "asc",
// 				searchQuery: "",
// 				filters: {
// 					name: { value: "", matchMode: "contains" },
// 					"country.name": { value: "", matchMode: "contains" },
// 					company: { value: "", matchMode: "contains" },
// 					"representative.name": { value: "", matchMode: "contains" },
// 				},
// 			});
// 		}
// 	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);
 
// 	const onSelectionModelChange = useCallback(
// 		(items: any) => {
// 			let selectedItemsIds = items.value.map((item: any) => item.id);
// 			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
// 				return rows && rows.find((row: any) => row.id === selectedItem.id);
// 			});
// 			setSelectedItems(updatedSelectedItems);
// 			setSelectedAuditEarningsItems(updatedSelectedItems);
// 			setSelectedItemsIds(selectedItemsIds);
// 			if (selectedRowsValues) {
// 				if (items.value.length > 0) {
// 					const selectedRowData = rows.filter((row: any) => {
// 						return items.value.includes(row);
// 					});
 
// 					selectedRowsValues(selectedRowData);
// 				} else {
// 					selectedRowsValues(items.value);
// 				}
// 			}
// 		},
// 		[rows, selectedRowsValues]
// 	);
 
// 	useEffect(() => {
// 		const updatedSelectedItems =
// 			selectedItems &&
// 			selectedItems.length > 0 &&
// 			selectedItems.filter((selectedItem: any) => {
// 				return rows && rows.find((row: any) => row.id === selectedItem.id);
// 			});
// 		if (
// 			updatedSelectedItems &&
// 			updatedSelectedItems.length !== selectedItems.length
// 		) {
// 			setSelectedItems(updatedSelectedItems);
 
// 			const updatedSelectedItemsIds = updatedSelectedItems.map(
// 				(item: any) => item.id
// 			);
// 			setSelectedItemsIds(updatedSelectedItemsIds);
// 		}
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	}, [rows, selectedItems]);
 
// 	const updateEmployeeListItemField = useCallback(
// 		(rowId: any, field: string, value: any) => {
// 			setEmployeeListItems((prev: any[]) => {
// 				if (!prev) return prev;
// 				const index = prev.findIndex((item) => item.id === rowId);
// 				if (index === -1) return prev;
// 				const updated = [...prev];
// 				updated[index] = { ...updated[index], [field]: value };
// 				return updated;
// 			});
// 		},
// 		[]
// 	);
 
// 	const onCellEditComplete = useCallback((e: any) => {
// 		const { rowData, newValue, field, originalEvent: event } = e;
 
// 		if (
// 			newValue === null ||
// 			(typeof newValue === "string" && newValue.trim().length === 0)
// 		) {
// 			event.preventDefault();
// 			return;
// 		}
 
// 		if (DIRECT_ASSIGN_FIELDS.has(field)) {
// 			rowData[field] = newValue;
// 		} else if (field === "dateOfHire") {
// 			rowData[field] = formatDate(newValue);
// 		} else if (field === "socialInsuranceNumber") {
// 			rowData[field] = addDashesInSIN(newValue);
// 		} else if (field === "phone") {
// 			rowData[field] = formatPhoneNo(newValue);
// 		}
 
// 		setEmployeeListItems((prev: any[]) => [...prev]);
// 	}, []);
 
// 	// ─── Generic editors (no per-row async work) ───────────────────────────
// 	const textEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 				const value = e.target.value;
// 				updateEmployeeListItemField(rowData.id, field, value);
// 				options.editorCallback(value);
// 			};
// 			return (
// 				<InputText
// 					value={options.value}
// 					onChange={handleChange}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					style={{ width: "180px" }}
// 				/>
// 			);
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	const textEditorForInitial = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 				const value = e.target.value;
// 				updateEmployeeListItemField(rowData.id, field, value);
// 				options.editorCallback(value);
// 			};
// 			return (
// 				<InputText
// 					value={options.value}
// 					onChange={handleChange}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					maxLength={3}
// 				/>
// 			);
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	const socialInsuranceNumberFieldEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const handleChange = (e: any) => {
// 				const value = e.target.value;
// 				updateEmployeeListItemField(rowData.id, field, value);
// 				options.editorCallback(value);
// 			};
// 			return (
// 				<InputMask
// 					value={options.value}
// 					onChange={handleChange}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					mask="999-999-999"
// 					unmask={true}
// 					autoClear={false}
// 				/>
// 			);
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	const phoneNumberFieldEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const handleChange = (e: any) => {
// 				const value = e.target.value;
// 				updateEmployeeListItemField(rowData.id, field, value);
// 				options.editorCallback(value);
// 			};
// 			return (
// 				<InputMask
// 					value={options.value}
// 					onChange={handleChange}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					mask="(999) 999-9999"
// 					unmask={true}
// 					autoClear={false}
// 				/>
// 			);
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	const makeStaticDdlEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const onChange = (e: any) => {
// 				const newValue = e.value;
// 				updateEmployeeListItemField(rowData.id, field, newValue);
// 				options.editorCallback(newValue);
// 			};
// 			return onChange;
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	const genderDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={GENDER_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const stubLanguageDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={STUB_LANGUAGE_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const emailStubDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={YES_NO_200_100_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const printHourlyRateOnStubDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={YES_NO_200_100_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const payFrequencyDdlEditor = useCallback(
// 		(options: any) => {
// 			// Resolve the current value (label -> id) without mutating the
// 			// options object PrimeReact handed us.
// 			const resolvedValue = getDDLValueByLabel(
// 				payFrequencyDDLItems,
// 				options.value
// 			);
// 			return (
// 				<Dropdown
// 					options={payFrequencyDDLItems ?? []}
// 					value={resolvedValue}
// 					onChange={makeStaticDdlEditor(options)}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					style={{ width: "100%" }}
// 				/>
// 			);
// 		},
// 		[payFrequencyDDLItems, makeStaticDdlEditor]
// 	);
// 	const payMethodDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={PAY_METHOD_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const includeInT4OrRl1DdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={YES_NO_200_100_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const vacationPayDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={VACATION_PAY_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const dentalBenefitsDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={DENTAL_BENEFITS_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const payOutVacationPayDdlEditor = useCallback(
// 		(options: any) => (
// 			<Dropdown
// 				options={YES_NO_200_100_OPTIONS}
// 				value={options.value}
// 				onChange={makeStaticDdlEditor(options)}
// 				placeholder="--"
// 				onKeyDown={(e) => e.stopPropagation()}
// 				style={{ width: "100%" }}
// 			/>
// 		),
// 		[makeStaticDdlEditor]
// 	);
// 	const vacationPayOpenBalanceEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const handleChange = (e: any) => {
// 				const value = e.target.value;
// 				updateEmployeeListItemField(rowData.id, field, value);
// 				options.editorCallback(value);
// 			};
// 			return (
// 				<InputNumber
// 					value={options.value}
// 					onChange={handleChange}
// 					placeholder="0.00"
// 					minFractionDigits={2}
// 					maxFractionDigits={2}
// 					inputStyle={{ textAlign: "right" }}
// 				/>
// 			);
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	// ─── Province DDL editor ────────────────────────────────────────────────
// 	// Cache province lists per country so we never re-fetch on every render
// 	// of every cell. Only fetch when a country hasn't been seen yet.
// 	const provinceByCountryRef = useRef<Map<string, any>>(new Map());
// 	const [, forceProvinceCacheTick] = useState(0);
 
// 	const fetchProvincesForCountry = useCallback(
// 		async (countryCode: any) => {
// 			if (!countryCode || provinceByCountryRef.current.has(countryCode)) {
// 				return;
// 			}
// 			// Mark as "in flight" immediately so we don't fire duplicate requests.
// 			provinceByCountryRef.current.set(countryCode, undefined);
// 			try {
// 				const response = await CountryService.getProvinceOrStateDDL(
// 					navigateToLogout,
// 					countryCode,
// 					"Province"
// 				);
// 				provinceByCountryRef.current.set(countryCode, response);
// 				forceProvinceCacheTick((t) => t + 1);
// 			} catch (err) {
// 				provinceByCountryRef.current.delete(countryCode);
// 				console.error("error", err);
// 			}
// 		},
// 		[navigateToLogout]
// 	);
 
// 	const provinceDdlEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const countryCode = rowData.country ?? undefined;
// 			const cached = countryCode
// 				? provinceByCountryRef.current.get(countryCode)
// 				: undefined;
 
// 			useEffect(() => {
// 				fetchProvincesForCountry(countryCode);
// 				// eslint-disable-next-line react-hooks/exhaustive-deps
// 			}, [countryCode]);
 
// 			const onChange = (e: any) => {
// 				const newValue = e.value;
// 				updateEmployeeListItemField(rowData.id, field, newValue);
// 				options.editorCallback(newValue);
// 			};
// 			return (
// 				<Dropdown
// 					options={cached ?? []}
// 					value={options.value}
// 					onChange={onChange}
// 					placeholder="--"
// 					onKeyDown={(e) => e.stopPropagation()}
// 					style={{ width: "100%" }}
// 				/>
// 			);
// 		},
// 		[fetchProvincesForCountry, updateEmployeeListItemField]
// 	);
 
// 	const postalCodeNumberFieldEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const handleChange = (e: any) => {
// 				const value = e.target.value;
// 				updateEmployeeListItemField(rowData.id, field, value);
// 				options.editorCallback(value);
// 			};
// 			return (
// 				<InputMask
// 					value={options.value}
// 					onChange={handleChange}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					mask="a9a9a9"
// 					unmask={true}
// 					autoClear={false}
// 					style={{ textTransform: "uppercase" }}
// 				/>
// 			);
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	const zipCodeNumberFieldEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const handleChange = (e: any) => {
// 				const value = e.target.value;
// 				updateEmployeeListItemField(rowData.id, field, value);
// 				options.editorCallback(value);
// 			};
// 			return (
// 				<InputMask
// 					value={options.value}
// 					onChange={handleChange}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					mask="00000"
// 					unmask={true}
// 					autoClear={false}
// 				/>
// 			);
// 		},
// 		[updateEmployeeListItemField]
// 	);
 
// 	const poeDdlEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const resolvedValue = getProvinceDDLValueByShortCode(
// 				provinceOfEmployementDDL,
// 				options.value
// 			);
// 			const onChange = (e: any) => {
// 				const newValue = e.value;
// 				updateEmployeeListItemField(rowData.id, field, newValue);
// 				options.editorCallback(newValue);
// 			};
// 			return (
// 				<Dropdown
// 					options={provinceOfEmployementDDL || []}
// 					value={resolvedValue}
// 					onChange={onChange}
// 					onKeyDown={(e) => e.stopPropagation()}
// 					style={{ width: "100%" }}
// 					disabled={!provinceOfEmployementDDL}
// 				/>
// 			);
// 		},
// 		[provinceOfEmployementDDL, updateEmployeeListItemField]
// 	);
 
// 	const countryDdlEditor = useCallback(
// 		(options: any) => {
// 			const { rowData, field } = options;
// 			const onChange = (e: any) => {
// 				const newValue = e.value;
// 				updateEmployeeListItemField(rowData.id, field, newValue);
// 				options.editorCallback(newValue);
// 			};
// 			return (
// 				<Dropdown
// 					options={countryList || []}
// 					value={options.value}
// 					onChange={onChange}
// 					placeholder="--"
// 					onKeyDown={(e) => e.stopPropagation()}
// 					style={{ width: "100%" }}
// 					disabled={!countryList}
// 				/>
// 			);
// 		},
// 		[countryList, updateEmployeeListItemField]
// 	);
 
// 	const cellEditor = useCallback(
// 		(options: any) => {
// 			switch (options.field) {
// 				case "employeeId":
// 				case "firstName":
// 				case "lastName":
// 				case "addressLine1":
// 				case "email":
// 				case "city":
// 					return textEditor(options);
// 				case "initial":
// 					return textEditorForInitial(options);
// 				case "gender":
// 					return genderDdlEditor(options);
// 				case "socialInsuranceNumber":
// 					return socialInsuranceNumberFieldEditor(options);
// 				case "phone":
// 					return phoneNumberFieldEditor(options);
// 				case "province":
// 					return provinceDdlEditor(options);
// 				case "postCode":
// 					return postalCodeNumberFieldEditor(options);
// 				case "zipCode":
// 					return zipCodeNumberFieldEditor(options);
// 				case "stubLanguage":
// 					return stubLanguageDdlEditor(options);
// 				case "emailStub":
// 					return emailStubDdlEditor(options);
// 				case "printHourlyRateOnStub":
// 					return printHourlyRateOnStubDdlEditor(options);
// 				case "payMethod":
// 					return companyInformation && companyInformation.paymentSetup !== 100
// 						? payMethodDdlEditor(options)
// 						: <span>{options.value}</span>;
// 				case "provinceOfEmployment":
// 					return poeDdlEditor(options);
// 				case "country":
// 					return countryDdlEditor(options);
// 				case "includeInT4OrRl1":
// 					return includeInT4OrRl1DdlEditor(options);
// 				case "vacationPay":
// 					return vacationPayDdlEditor(options);
// 				case "dentalBenefits":
// 					return dentalBenefitsDdlEditor(options);
// 				case "payOutVacationPay":
// 					return payOutVacationPayDdlEditor(options);
// 				case "vacationPayOpenBalance":
// 					return vacationPayOpenBalanceEditor(options);
// 				default:
// 					return <span>{options.value}</span>;
// 			}
// 		},
// 		[
// 			textEditor,
// 			textEditorForInitial,
// 			genderDdlEditor,
// 			socialInsuranceNumberFieldEditor,
// 			phoneNumberFieldEditor,
// 			provinceDdlEditor,
// 			postalCodeNumberFieldEditor,
// 			zipCodeNumberFieldEditor,
// 			stubLanguageDdlEditor,
// 			emailStubDdlEditor,
// 			printHourlyRateOnStubDdlEditor,
// 			companyInformation,
// 			payMethodDdlEditor,
// 			poeDdlEditor,
// 			countryDdlEditor,
// 			includeInT4OrRl1DdlEditor,
// 			vacationPayDdlEditor,
// 			dentalBenefitsDdlEditor,
// 			payOutVacationPayDdlEditor,
// 			vacationPayOpenBalanceEditor,
// 		]
// 	);
 
// 	const columnsBody = useCallback(
// 		(rowData: any, row: any, x: any) => {
// 			if (x.field === "provinceOfEmployment") {
// 				const selected = provinceOfEmployementDDL?.find(
// 					(item: { value: any }) => item.value === rowData[x.field]
// 				);
// 				return selected ? selected.label : rowData[x.field];
// 			} else if (x.field === "country") {
// 				const selected = countryList?.find(
// 					(item: { value: any }) => item.value === rowData[x.field]
// 				);
// 				return selected ? selected.label : rowData[x.field];
// 			} else if (x.field === "socialInsuranceNumber") {
// 				return rowData[x.field]?.charAt(2) === "*"
// 					? "Unmask to view / edit"
// 					: addDashesInSIN(rowData[x.field]);
// 			} else if (x.field === "email") {
// 				return rowData[x.field]?.charAt(2) === "*"
// 					? "Unmask to view / edit "
// 					: rowData[x.field];
// 			} else if (x.field === "province") {
// 				const selected = provinceOfEmployementDDL?.find(
// 					(item: { value: any }) =>
// 						item.value === rowData[x.field] && rowData[x.field]
// 				);
// 				return selected ? selected.label : rowData[x.field];
// 			} else if (x.field === "dateOfHire" || x.field === "dateOfBirth") {
// 				return rowData[x.field] && rowData[x.field]?.charAt(2) === "*"
// 					? "Unmask to view"
// 					: rowData[x.field];
// 			} else if (x.field === "split") {
// 				return rowData[x.field] === 100
// 					? "No Split"
// 					: rowData[x.field] === 200
// 						? "Percentage"
// 						: "Fixed Amount";
// 			} else if (x.field === "gender") {
// 				return rowData[x.field] === 200 ? "Male" : "Female";
// 			} else if (x.field === "payFrequency") {
// 				return getDDLLabelByValue(payFrequencyDDLItems, rowData[x.field]);
// 			} else if (x.field === "payMethod") {
// 				return companyInformation && companyInformation.paymentSetup === 100
// 					? "Cheque"
// 					: rowData[x.field] === 100
// 						? "Cash"
// 						: rowData[x.field] === 200
// 							? "Cheque"
// 							: rowData[x.field] === 300
// 								? "Direct Deposit"
// 								: "";
// 			} else if (x.field === "vacationPay") {
// 				return rowData[x.field] === 100 ? "Calculate" : "Disable";
// 			} else if (x.field === "payOutVacationPay") {
// 				return rowData[x.field] === 100 ? "No" : "Yes";
// 			} else if (x.field === "includeInT4OrRl1") {
// 				return rowData[x.field] === 100 ? "No" : "Yes";
// 			} else if (x.field === "dentalBenefits") {
// 				return rowData[x.field] === 100
// 					? "Not eligible"
// 					: rowData[x.field] === 200
// 						? "Payee only"
// 						: rowData[x.field] === 300
// 							? "Payee, Spouse, Children"
// 							: rowData[x.field] === 400
// 								? "Payee, Spouse"
// 								: "Payee, Children";
// 			} else if (x.field === "sinStatus") {
// 				return rowData[x.field] === 100
// 					? "Pending"
// 					: rowData[x.field] === 200
// 						? "Refused"
// 						: rowData[x.field] === 300
// 							? "Failed to Provide"
// 							: rowData[x.field] === 400
// 								? "Recorded"
// 								: "Recorded Incorrect";
// 			} else if (x.field === "stubLanguage") {
// 				return rowData[x.field] === 100 ? "English" : "French";
// 			} else if (x.field === "emailStub") {
// 				return rowData[x.field] === 100 ? "No" : "Yes";
// 			} else if (x.field === "printHourlyRateOnStub") {
// 				return rowData[x.field] === 100 ? "No" : "Yes";
// 			} else if (x.field === "vacationPayOpenBalance") {
// 				return parseFloat(rowData[x.field])
// 					.toFixed(2)
// 					.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// 			} else {
// 				return <span>{rowData[x.field]}</span>;
// 			}
// 		},
// 		[provinceOfEmployementDDL, countryList, payFrequencyDDLItems, companyInformation]
// 	);
 
// 	// ─── STICKY HEADER ──────────────────────────────────────────────────────
// 	const containerRef = useStickyDataTableHeader<HTMLDivElement>([columns], {
// 		navbarHeight: 112,
// 		frozenColumnSelector: ".p-frozen-column, .selectionHeader",
// 		selectionHeaderSelector: ".selectionHeader",
// 	});
 
// 	// Sort columns once per `columns` change instead of on every render, and
// 	// never mutate the array the parent gave us.
// 	const sortedColumns = useMemo(() => {
// 		if (!columns) return columns;
// 		return [...columns].sort(
// 			(a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0)
// 		);
// 	}, [columns]);
 
// 	const editableFields = useMemo(() => {
// 		const set = new Set(BASE_EDITABLE_FIELDS);
// 		if (companyInformation?.paymentSetup === 100) {
// 			set.delete("payMethod");
// 		}
// 		if (maskStatus) {
// 			set.delete("socialInsuranceNumber");
// 			set.delete("email");
// 		}
// 		return set;
// 	}, [companyInformation, maskStatus]);
 
// 	const renderedColumns = useMemo(() => {
// 		if (!sortedColumns) return null;
// 		return sortedColumns.map((x: any, index: any) => (
// 			<Column
// 				key={x.field ?? index}
// 				field={x.field}
// 				header={x.headerName}
// 				headerTooltipOptions={{ position: "top" }}
// 				hidden={x.hide}
// 				sortable={x.sortable}
// 				dataType={x.type}
// 				align={x.align}
// 				alignHeader={x.headerAlign}
// 				exportable={x.disableExport}
// 				frozen={x.frozenColumn}
// 				alignFrozen={x.alignFrozen}
// 				columnKey={x.field}
// 				style={{
// 					minWidth: x.minWidth,
// 					fontSize: "0.875rem",
// 					maxWidth: x.maxWidth,
// 				}}
// 				headerStyle={{
// 					whiteSpace: whiteSpace ? whiteSpace : "nowrap",
// 				}}
// 				footer={x.footer}
// 				editor={editableFields.has(x.field) ? cellEditor : undefined}
// 				onCellEditComplete={onCellEditComplete}
// 				body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
// 			/>
// 		));
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	}, [sortedColumns, editableFields, cellEditor, onCellEditComplete, columnsBody, whiteSpace]);
 
// 	return (
// 		<>
// 			{rows && provinceOfEmployementDDL ? (
// 				<div ref={containerRef}>
// 					<DataTable
// 						value={
// 							rows && columns && visibleColumns.length > 0 && rows && employeeListItems
// 						}
// 						responsiveLayout="scroll"
// 						lazy
// 						dataKey="id"
// 						paginator
// 						first={requestParams.first}
// 						rows={requestParams.rows}
// 						totalRecords={totalRecords}
// 						onPage={onPage}
// 						rowsPerPageOptions={rowsPerPageOptions}
// 						paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
// 						currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
// 						selection={selectedItems}
// 						onSelectionChange={onSelectionModelChange}
// 						editMode="cell"
// 						selectionMode={"checkbox"}
// 						showGridlines
// 						resizableColumns
// 						columnResizeMode="expand"
// 						scrollable
// 						scrollHeight={tableScrollHeight ? "75vh" : ""}
// 						onColReorder={onColReorder}
// 						header={searchFieldPlaceholder ? headerSearch : undefined}
// 						footer={footer ? footer : undefined}
// 						emptyMessage={
// 							rows && rows.length === 0 ? "No Record Found." : "Loading..."
// 						}
// 						className="PrimeDataGridWithColumnToggled"
// 						style={{
// 							margin: `${tableMargin ? tableMargin : "14px 0 0.5rem 0"}`,
// 						}}
// 						sortMode="single"
// 						onSort={onSort}
// 					>
// 						{columns && visibleColumns.length > 0 && rows && rows.length > 0 && (
// 							<Column
// 								selectionMode="multiple"
// 								hidden={!showChecboxColumn}
// 								frozen
// 								resizeable={false}
// 								style={{ width: "36px", textAlign: "center" }}
// 								field="selection"
// 								alignFrozen="left"
// 								columnKey="selection"
// 								className="selectionHeader"
// 								headerClassName="selectionHeader"
// 							></Column>
// 						)}
// 						{rows && rows.length ? (
// 							<Column
// 								body={editColumn}
// 								style={{ width: "36px" }}
// 								hidden={!showSettingColumn}
// 								resizeable={false}
// 								reorderable={false}
// 								frozen
// 								alignFrozen="left"
// 								headerClassName="settingHeader"
// 							></Column>
// 						) : undefined}
 
// 						{rows && rows.length ? (
// 							<Column
// 								header="#"
// 								className="indexColumn"
// 								headerClassName="indexColumn"
// 								headerStyle={{ width: "24px" }}
// 								frozen
// 								hidden={!showIndexColumn}
// 								body={(data, options) => options.rowIndex + 1}
// 							></Column>
// 						) : undefined}
 
// 						{renderedColumns}
 
// 						{rows && rows.length ? (
// 							<Column
// 								body={deleteRowColumn}
// 								style={{
// 									width: "36px",
// 									position: exportButtonInFileList ? "relative" : "sticky",
// 									overflow: exportButtonInFileList ? "visible" : "hidden",
// 								}}
// 								hidden={!showSettingColumn}
// 								resizeable={false}
// 								reorderable={false}
// 								frozen
// 								alignFrozen="right"
// 								className="settingHeader"
// 								headerClassName="settingHeader"
// 							></Column>
// 						) : undefined}
// 					</DataTable>
// 				</div>
// 			) : (
// 				<p>Data is loading...</p>
// 			)}
// 		</>
// 	);
// };
